import React, { useState, useEffect } from "react";
import { Layout, Menu, Dropdown, Button, Spin } from "antd";
import { Outlet, Link, useLocation } from "react-router-dom";
import "./MainLayout.css"; // Import the CSS file
import AdminHeader from "./components/AdminHeader/AdminHeader";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import logo from "../Assets/svg/TPMlogo.svg";
import menu1 from "../Assets/svg/menuIcon1.svg";
// import menu3 from "../Assets/svg/menu3.svg";
import menu2 from "../Assets/svg/menuIcon2.svg";
import budgetsummarylogo from "../Assets/svg/budgetsummarylogo.svg";
import offices from "../Assets/svg/office.svg";
import icon7 from "../Assets/svg/iconMenu7.svg";
import SettingsButton from "../Assets/svg/settingsButton.svg";
import { useNavigate } from "react-router-dom";
import { RolesEnum } from "../services/rolesEnum";
import { isAuthorized } from "../services/authService";
import AuthService from "../services/authentication.service";
import FooterComponent from "./components/FooterComponent/FooterComponent";
import {
  SidebarCollapseToggle,
  useSidebarCollapse,
} from "./components/SidebarCollapse/SidebarCollapse";

const { Header, Content, Sider, Footer } = Layout;

// Matches `.sider--rail` in MainLayout.css.
const RAIL_WIDTH = 76;

const MainLayout = ({
  notifications,
  setNotifications,
  unreadNotifications,
  setUnreadNotifications,
}) => {
  const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
  const location = useLocation();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  // `collapsed` above is the phone drawer; this is the desktop icons-only rail.
  const [iconsOnly, toggleIconsOnly] = useSidebarCollapse();
  const railMode = iconsOnly && !isSmallScreen;
  const navigate = useNavigate();

  // Track viewport size with a single, cleaned-up listener.
  useEffect(() => {
    const onResize = () => setIsSmallScreen(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleLogout = async () => {
    AuthService.logout();
  };

  // The admin sections, as antd items so the sider can fold down to icons.
  const adminMenuItems = [
    isAuthorized([
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
    ]) && {
      key: "1",
      label: "User Management",
      icon: <img src={menu1} alt="" />,
      path: "/dashboard/user-management",
    },
    {
      key: "2",
      label: "Contracts",
      icon: <img src={menu2} alt="" />,
      path: "/dashboard/contracts",
    },
    isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && {
      key: "3",
      label: "Budget Summary",
      icon: <img src={budgetsummarylogo} alt="" />,
      path: "/dashboard/budget-summary",
    },
    isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && {
      key: "6",
      label: "Offices",
      icon: <img src={offices} alt="" />,
      path: "/dashboard/offices",
    },
    {
      key: "5",
      label: "Account Settings",
      icon: <img src={SettingsButton} alt="" />,
      path: "/settings/profile-information",
    },
    {
      key: "7",
      label: "Logout",
      icon: <img src={icon7} alt="" />,
      className: "logoutMenu",
      onClick: handleLogout,
    },
  ]
    .filter(Boolean)
    .map((item) => ({
      ...item,
      className:
        item.path && location.pathname === item.path
          ? "costum-menu-item-active"
          : item.className || "",
      onClick: item.onClick || (() => navigate(item.path)),
    }));

  // Dropdown menu for small screens
  const menu = (
    <Menu theme="dark" mode="vertical">
      {" "}
      {isAuthorized([
        RolesEnum.ProjectManager,
        RolesEnum.SystemAdmin,
        RolesEnum.FieldCoordinator,
      ]) && (
        <Menu.Item key="1">
          <Link
            to="/dashboard/user-management"
            style={{ textDecoration: "none", color: "#6A113C" }}
          >
            User Management
          </Link>
        </Menu.Item>
      )}
      <Menu.Item key="2">
        <Link
          to="/dashboard/contracts"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Contracts
        </Link>
      </Menu.Item>
      {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
        <Menu.Item key="5">
          <Link
            to="/dashboard/offices"
            style={{ textDecoration: "none", color: "#6A113C" }}
          >
            Offices
          </Link>
        </Menu.Item>
      )}
      {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
        <Menu.Item key="3">
          <Link
            to="/dashboard/budget-summary"
            style={{ textDecoration: "none", color: "#6A113C" }}
          >
            Budget Summary
          </Link>
        </Menu.Item>
      )}
      <Menu.Item key="4">
        <Link
          to="/settings/budget-summary"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Account Settings
        </Link>
      </Menu.Item>
      {/* Add more menu items as needed */}
    </Menu>
  );

  return (
    <Spin spinning={loading}>
      <Layout style={{ minHeight: "100vh" }}>
        {isSmallScreen && collapsed ? null : (
          <Sider
            className={`sider${railMode ? " sider--rail" : ""}`}
            collapsed={railMode}
            collapsedWidth={RAIL_WIDTH}
            trigger={null}
            style={
              !collapsed ? { position: "fixed", right: "0", zIndex: 1001 } : {}
            }
          >
            <div className="siderHead">
              <a href="/dashboard/contracts" className="menuDesign">
                <img src={logo} className="siderLogo" alt="logo" />
              </a>
              {!isSmallScreen && (
                <SidebarCollapseToggle
                  collapsed={railMode}
                  onToggle={toggleIconsOnly}
                />
              )}
            </div>
            <p className="siderText">Admin Management</p>
            {/* Icons go in antd's `icon` slot rather than inside the label, which
                is what lets the menu collapse to icons — see SidebarMenu.jsx. */}
            <Menu
              theme="dark"
              mode="inline"
              inlineCollapsed={railMode}
              selectedKeys={[location.pathname]}
              className="menu"
              items={adminMenuItems}
            />
          </Sider>
        )}
        {isSmallScreen && !collapsed && (
          <div className="sider-overlay" onClick={() => setCollapsed(true)} />
        )}
        <Layout className="site-layout">
          {!isGuestShare && (
            <Header
              className="adminHeader d-flex align-items-center justify-content-between justify-content-md-end justify-content-lg-end justify-content-xl-end justify-content-xxl-end"
              style={{
                minHeight: "100px",
                padding: 0,
              }}
            >
              {collapsed ? (
                <AdminHeader
                  notifications={notifications}
                  setNotifications={setNotifications}
                  unreadNotifications={unreadNotifications}
                  setUnreadNotifications={setUnreadNotifications}
                />
              ) : (
                ""
              )}

              {isSmallScreen && (
                <Button
                  type="text"
                  icon={
                    collapsed ? (
                      <MenuOutlined
                        style={{
                          fontSize: 24,
                        }}
                      />
                    ) : (
                      <CloseOutlined
                        style={{
                          fontSize: 24,
                          color: "#fff",
                        }}
                      />
                    )
                  }
                  onClick={() => setCollapsed(!collapsed)}
                  style={
                    !collapsed
                      ? {
                          position: "fixed",
                          top: 25,
                          right: 16,
                          zIndex: 9999,
                          background: "transparent",
                          border: "none",
                          boxShadow: "none",
                        }
                      : {}
                  }
                />
              )}
            </Header>
          )}
          <Content style={{ margin: "0px", backgroundColor: "white" }}>
            <Outlet style={{ width: "100% !important" }} />
          </Content>
          <Footer>
            <FooterComponent></FooterComponent>
          </Footer>
        </Layout>
      </Layout>
    </Spin>
  );
};

export default MainLayout;
